var map = {
	"./@core/assets/fonts/feather/fonts/feather.svg": "e2aa",
	"./assets/images/icons/angular.svg": "9451",
	"./assets/images/icons/book.svg": "a337",
	"./assets/images/icons/bootstrap.svg": "2ea3",
	"./assets/images/icons/brush.svg": "815f",
	"./assets/images/icons/figma.svg": "7472",
	"./assets/images/icons/parachute.svg": "666b",
	"./assets/images/icons/paycard/amex.svg": "039e",
	"./assets/images/icons/paycard/credit-card.svg": "d432",
	"./assets/images/icons/paycard/diners.svg": "d9b1",
	"./assets/images/icons/paycard/discover.svg": "1f74",
	"./assets/images/icons/paycard/jcb.svg": "ec0b",
	"./assets/images/icons/paycard/maestro.svg": "1ff8",
	"./assets/images/icons/paycard/mastercard.svg": "d3f6",
	"./assets/images/icons/paycard/mir.svg": "0b49",
	"./assets/images/icons/paycard/union.svg": "1489",
	"./assets/images/icons/paycard/visa.svg": "0c97",
	"./assets/images/icons/react.svg": "f4d6",
	"./assets/images/icons/rocket.svg": "df02",
	"./assets/images/icons/speaker.svg": "1535",
	"./assets/images/icons/star.svg": "0a83",
	"./assets/images/icons/toolbox.svg": "40d5",
	"./assets/images/icons/vuejs.svg": "57c1",
	"./assets/images/logo/logo.svg": "ed29",
	"./assets/images/pages/coming-soon-dark.svg": "c09f",
	"./assets/images/pages/coming-soon.svg": "7b13",
	"./assets/images/pages/error-dark.svg": "e0c1",
	"./assets/images/pages/error.svg": "053b",
	"./assets/images/pages/forgot-password-v2-dark.svg": "6e2f",
	"./assets/images/pages/forgot-password-v2.svg": "5b2a",
	"./assets/images/pages/login-v2-dark.svg": "ff0f",
	"./assets/images/pages/login-v2.svg": "5aa9",
	"./assets/images/pages/login/facebook.svg": "4631",
	"./assets/images/pages/login/github.svg": "7b1ea",
	"./assets/images/pages/login/google.svg": "74c7",
	"./assets/images/pages/login/twitter.svg": "ceb3",
	"./assets/images/pages/not-authorized-dark.svg": "a357",
	"./assets/images/pages/not-authorized.svg": "e767",
	"./assets/images/pages/register-v2-dark.svg": "99b7",
	"./assets/images/pages/register-v2.svg": "67df",
	"./assets/images/pages/reset-password-v2-dark.svg": "aed4",
	"./assets/images/pages/reset-password-v2.svg": "ed94",
	"./assets/images/pages/under-maintenance-dark.svg": "189d",
	"./assets/images/pages/under-maintenance.svg": "70e7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fa53";